import { OccurrenceFormFields } from '@/components/assessments/forms/OccurrenceForm';
import { StudentAssessment } from '@/models/StudentAssessment';

export const occurrenceToFormFields = (
  assessment?: StudentAssessment,
): OccurrenceFormFields => ({
  studentId: assessment?.student?.id ?? null,
  description: assessment?.occurrenceAssessment?.description ?? '',
  notificable: assessment?.occurrenceAssessment?.notificable ?? true,
});
